import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";

 export class VendorCreditItemsBus extends BaseBus
 {
     constructor(busObj: BaseBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);
     }

     CID(): any {
         return this.vendorCreditItemId;
     }
     setId(id: any) {
         this.vendorCreditItemId = id;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
     }
     setParentId(id: any) {
         this.vendorCreditId = id;
     }
     changeInventoryItem(data: v_InventoryBus) {
         this.invNumber = data.number;
         this.invDesc = data.inventoryDesc;
         this.inventoryId = data.inventoryId;
     }
 orderDetailId: any;
 vendorCreditItemId: any;
 vendorCreditId: any;
 inventoryId: any;
 quantity: number;
 cost: number;
 classId: any;
 qbid: string;
 qbeditSequenceId: string;
 insertDt: Date;
 insertUserId: any;
 updateDt: Date;
 updateUserId: any;
 dispatchId: any;
 invDesc: string;
 orderId: any;
 pushedToInvoice: boolean ;
 accountClassName: string;
 invNumber: string;
 dispatchNumber: string;
     orderNumber: string;
     dummy: any;
 }
